import { Card } from '@/globalComponents/card';
import Image from '@/globalComponents/image';
import styles from './style.module.scss';
import { DarkBenefitIconMap } from '@/utils';
import { TierType } from '@/types/tier';

export type PlanBenefitsItemProps = {
  icon: string;
  title: string;
  description?: string;
};

const formatTitle = (title: string) => {
  const words = title.split(' ');
  if (words[0].toUpperCase() === 'FREE' && words.length > 1) {
    return (
      <>
        {words[0]} <br />
        {words.slice(1).join(' ')}
      </>
    );
  }
  return title;
};

export const renderCollapsedView = (
  dataSet: PlanBenefitsItemProps[],
  showExpandedView: boolean,
  tier: TierType,
) => {
  return (
    <div
      className={
        showExpandedView
          ? `grid grid-cols-1 px-3 pt-4 pb-5  md:grid-cols-2 md:gap-x-16 md:gap-y-12 lg:gap-x-28 md:p-5 md:px-8 md:pb-12 gap-s6`
          : `grid grid-cols-4 gap-s5 p-3`
      }
    >
      {dataSet.map((data, index) => {
        const { icon, title, description } = data;
        if (!showExpandedView && index > 3) {
          return <></>;
        }
        return (
          <Card
            classNames={
              showExpandedView
                ? `${styles.benefit} flex flex-row items-start`
                : `flex flex-col gap-s3 items-center justify-start ${styles.benefit}`
            }
            key={title}
            data-testid="benefitView"
          >
            <div
              className={
                showExpandedView
                  ? `relative w-12 h-12 md:w-[60px] md:h-[60px] mr-[0.75rem] shrink-0 ${styles.ellipse} ${styles[tier]}`
                  : `relative w-12 h-12 shrink-0 ${styles.ellipse} ${styles[tier]}`
              }
            >
              <Image
                src={DarkBenefitIconMap[icon]}
                alt="PlanBenefitsIcon"
                data-testid="benefitsIcon"
                className="w-5 h-5 top-3 right-3 md:w-[1.875rem] md:h-[1.875rem] absolute md:top-[0.85rem] md:right-[0.85rem]"
              />
            </div>
            <div>
              <p
                className={
                  showExpandedView
                    ? `${styles.title} md:pb-[0.625rem] pb-1 font-medium text-[0.8125rem] md:text-lg leading-[1rem] md:leading-[1.375rem]`
                    : `${styles.title} flex font-medium text-[0.625rem] text-center leading-[0.875rem]`
                }
                data-testid="benefitsTitle"
              >
                {!showExpandedView ? formatTitle(title) : title}
              </p>
              <p
                className={
                  showExpandedView
                    ? `${styles.description} font-normal text-xs leading-4 md:text-base md:leading-5 text-[#707070]`
                    : `hidden`
                }
                data-testid="benefitsDescription"
              >
                {description}
              </p>
            </div>
          </Card>
        );
      })}
    </div>
  );
};
